import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

const { mediaQuery, font, color } = baseVariables;

export const StyledCompareHotelsModal = styled.div`
  .compare-hotels-modal {
    border-radius: ${toRem(14)} ${toRem(14)} 0 0;

    .header-heading {
      font-size: ${font.fontL};
      line-height: ${font.lineHeightXl};
      font-weight: ${font.fontWeightMedium};
    }

    .modal-body {
      .card-container {
        height: 100%;
        .compact-card {
          height: 100%;
        }
      }

      .carousel-nav {
        cursor: pointer;
      }

      .map-container {
        border-radius: ${toRem(15)};
        overflow: hidden;
        .map-marker {
          width: 80%;
          white-space: normal;
          font-weight: ${font.fontWeightRegular};
          line-height: ${font.lineHeightM};
          background-color: ${color.base20};
        }
        .gm-style-mtc button,
        .gm-fullscreen-control,
        .gm-svpc,
        .gm-control-active,
        .gm-style-cc button {
          &:focus-visible {
            outline: -webkit-focus-ring-color auto ${toRem(1)};
          }
        }
      }
    }

    .modal-footer {
      background-color: ${color.base20};
      border-top: none;
    }

    @media ${mediaQuery.md} {
      border-radius: ${toRem(14)};

      .header-heading {
        font-size: ${font.fontXxl};
        line-height: ${font.lineHeightXxl};
      }

      .modal-body {
        max-height: 68dvh !important;
      }
    }
  }
`;
